import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { labelBanco } from 'src/app/enum/banco-integracao.enum';
import { ContaCorrente } from 'src/app/page/conta-corrente/contacorrente';
import { Segmento } from 'src/app/page/segmento/segmento';
import { BaixaLinha, ContaFinanceiraUiConfig } from './conta-financeira.model';
import { labelFormaPagamento } from './conta-financeira.util';

interface PagadorOpcao {
  id: number;
  razaoSocial: string;
}

@Component({
  selector: 'app-conta-financeira-cadastro',
  templateUrl: './conta-financeira-cadastro.component.html',
  styleUrls: ['./conta-financeira-form.scss'],
})
export class ContaFinanceiraCadastroComponent {

  @Input() formulario!: FormGroup;
  @Input() baixaForm!: FormGroup;
  @Input() myControl!: FormControl;
  @Input() pagadoresLista: PagadorOpcao[] = [];
  @Input() bloquearCampoEdicao = false;
  @Input() config!: ContaFinanceiraUiConfig;
  @Input() valorPago = 0;
  @Input() valorRestante = 0;
  @Input() statusPagamento = '';
  @Input() baixas: BaixaLinha[] = [];
  @Input() contaAberta = true;
  @Input() possuiAnexoFatura = false;
  @Input() possuiAnexoBaixa = false;
  @Input() nomeArquivoFaturaSelecionado = '';
  @Input() nomeArquivoBaixaSelecionado = '';
  @Input() nomeArquivoFaturaSalvo = '';
  @Input() temContaSalva = false;
  @Input() contasCorrentes: ContaCorrente[] = [];
  @Input() segmentos: Segmento[] = [];

  @Output() calcularTotal = new EventEmitter<void>();
  @Output() listarPagador = new EventEmitter<void>();
  @Output() selecionarFatura = new EventEmitter<Event>();
  @Output() selecionarComprovante = new EventEmitter<Event>();
  @Output() anexarFatura = new EventEmitter<void>();
  @Output() registrarBaixa = new EventEmitter<void>();
  @Output() baixarAnexo = new EventEmitter<'fatura' | 'baixa'>();
  @Output() copiarPix = new EventEmitter<string>();
  @Output() baixarBolepix = new EventEmitter<void>();
  @Output() baixarComprovantePix = new EventEmitter<void>();

  labelForma = labelFormaPagamento;

  labelContaCorrente(conta: ContaCorrente): string {
    const banco = labelBanco(conta.banco);
    return banco ? `${conta.descricao} — ${banco}` : conta.descricao;
  }

  exibirDadosCobranca(): boolean {
    if (!this.config?.exibirDadosBanco || !this.formulario) {
      return false;
    }
    const v = this.formulario.value;
    return ['BOLETO', 'PIX'].includes(v?.formaCobranca)
      || !!(v?.nossoNumero || v?.linhaDigitavel || v?.txidPix || v?.pixCopiaECola || v?.statusCobrancaSicoob);
  }

  exibirBlocoBoleto(): boolean {
    const v = this.formulario?.value;
    return v?.formaCobranca === 'BOLETO' || !!(v?.nossoNumero || v?.linhaDigitavel);
  }

  exibirBlocoPix(): boolean {
    const v = this.formulario?.value;
    return v?.formaCobranca === 'PIX' || !!(v?.txidPix || v?.pixCopiaECola);
  }

  camposBancoReadonly(): boolean {
    return this.formulario?.value?.statusCobrancaSicoob === 'EMITIDO';
  }

  abrirUrlBoleto(): void {
    const url = this.formulario?.value?.urlBoletoPdf;
    if (url) {
      window.open(url, '_blank');
    }
  }

  urlQrCodePix(pixCopiaECola: string): string {
    if (!pixCopiaECola) {
      return '';
    }
    return 'https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=' + encodeURIComponent(pixCopiaECola);
  }

  displayFn(pagador: PagadorOpcao | string): string {
    if (pagador && (pagador as PagadorOpcao).razaoSocial) {
      return (pagador as PagadorOpcao).razaoSocial;
    }
    return typeof pagador === 'string' ? pagador : '';
  }
}
